import SignupForm from '@/components/SignupForm';
import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function KashlySignupPage() {
  const { t, i18n } = useTranslation();
  const features = [
    'Full POS system with product & service billing',
    'Stock management with low-stock alerts',
    'Customer database & outstanding tracking',
    'Daily sales reports & analytics',
    'Multi-user access for your team',
    'Optional sample data to explore',
  ];

  return (
    <div className="min-h-screen flex">
      {/* ── Left panel ── */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden bg-[#06063B] flex-col items-center justify-center p-12">
        {/* Ambient glows */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#1FA8FF]/20 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#1FA8FF]/10 rounded-full blur-[100px] translate-y-1/2 -translate-x-1/2" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(31,168,255,0.08)_0%,_transparent_70%)]" />

        {/* Grid pattern overlay */}
        <div
          className="absolute inset-0 opacity-[0.04]"
          style={{
            backgroundImage:
              'linear-gradient(rgba(255,255,255,1) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,1) 1px,transparent 1px)',
            backgroundSize: '48px 48px',
          }}
        />

        <div className="relative z-10 max-w-md w-full" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
          {/* Logo on white pill — keeps dark SVG visible */}
          <div className="bg-white rounded-2xl px-8 py-5 inline-block mb-10 shadow-xl shadow-black/30">
            <img 
              src={i18n.language === 'ar' ? '/kashly-logo-ar.png' : '/kashly-logo-en.png'} 
              alt="Kashly" 
              className="h-12 w-auto" 
            />
          </div>

          <h2 className="text-3xl font-bold text-white mb-3 leading-tight">
            {t('auth.startFreeTrial', 'Start Your Free Trial')}
          </h2>
          <p className="text-blue-200 text-sm mb-10 leading-relaxed">
            {t('auth.trialSubtitle', 'Get full access for 3 days. No credit card required. Setup takes less than 5 minutes.')}
          </p>

          <div className="space-y-4">
            {features.map((item) => (
              <div key={item} className="flex items-center gap-4">
                <div className="w-8 h-8 rounded-lg bg-[#1FA8FF]/20 border border-[#1FA8FF]/30 flex items-center justify-center flex-shrink-0">
                  <Check className="w-4 h-4 text-[#1FA8FF]" />
                </div>
                <div>
                  <p className="text-white font-medium text-sm">{t(`auth.signupFeatures.${item}`, item)}</p>
                </div>
              </div>
            ))}
          </div>

          <p className="mt-12 text-blue-400 text-xs">
            © {new Date().getFullYear()} Kashly. {t('auth.allRightsReserved', 'All rights reserved.')}
          </p>
        </div>
      </div>

      {/* ── Right panel (form) ── */}
      <div className="flex-1 flex flex-col items-center justify-center bg-gray-50 p-6">
        <div className="w-full max-w-md py-8">

          {/* Mobile-only logo */}
          <div className="lg:hidden flex justify-center mb-8">
            <div className="bg-white rounded-2xl px-6 py-4 shadow-md border border-gray-100">
              <img 
                src={i18n.language === 'ar' ? '/kashly-logo-ar.png' : '/kashly-logo-en.png'} 
                alt="Kashly" 
                className="h-10 w-auto" 
              />
            </div>
          </div>

          <SignupForm hideHeader />

        </div>
      </div>
    </div>
  );
}
